import { render, staticRenderFns } from "./OctTextField.vue?vue&type=template&id=1d212204&scoped=true&"
import script from "./OctTextField.vue?vue&type=script&lang=js&"
export * from "./OctTextField.vue?vue&type=script&lang=js&"
import style0 from "./OctTextField.vue?vue&type=style&index=0&id=1d212204&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d212204",
  null
  
)

export default component.exports